const monthNamesUA = [
  'січня',
  'лютого',
  'березня',
  'квітня',
  'травня',
  'червня',
  'липня',
  'серпня',
  'вересня',
  'жовтня',
  'листопада',
  'грудня',
];

export const formatDate = (dateString, format, shortYear = false) => {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const currentYear = new Date().getFullYear();

  const showYear = !(shortYear && year === currentYear);

  if (format === 'UA') {
    return showYear ? `${day}.${month}.${year}` : `${day}.${month}`;
  } else {
    return showYear ? `${year}-${month}-${day}` : `${month}-${day}`;
  }
};

export const formatDateTimeUA = (dateString, useMonthName = false) => {
  const date = new Date(dateString);
  const now = new Date();

  const day = useMonthName ? date.getDate() : String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  const hours = useMonthName ? date.getHours() : String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  if (useMonthName) {
    if (year === now.getFullYear()) {
      return `${day} ${monthNamesUA[date.getMonth()]}, ${hours}:${minutes}`;
    } else {
      return `${day} ${monthNamesUA[date.getMonth()]} ${year}, ${hours}:${minutes}`;
    }
  }

  if (year === now.getFullYear()) {
    return `${hours}:${minutes}, ${day}.${month}`;
  } else {
    return `${hours}:${minutes}, ${day}.${month}.${year}`;
  }
};
